import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { RoleGuard } from './core/auth/role-guard';
import { andonRoutes } from './features/andon/andon.routes';
import { documentsRoutes } from './features/documents/documents.routes';
import { HomeComponent } from './features/home/pages/home.component';
import { marketsRoutes } from './features/markets/markets.routes';
import { serviceRequestsResolver } from './features/requests/resolvers/service-requests.resolver';
import { requestsRoutes } from './features/requests/service-request.routes';
import { UserSettingsComponent } from './features/user-settings/user-settings.component';

export const routes: Routes = [
  ...andonRoutes,
  ...marketsRoutes,
  ...documentsRoutes,
  ...requestsRoutes,
  {
    path: '',
    canActivateChild: [MsalGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        resolve: {
          serviceRequests: serviceRequestsResolver,
        },
      },
      {
        path: 'settings',
        component: UserSettingsComponent,
      },
      {
        path: 'user-administration',
        title: 'User Administration',
        loadComponent: () =>
          import('./features/user-administration/user-administration.component').then(
            module => module.UserAdministrationComponent
          ),
        data: {
          roles: ['SuperAdmin', 'Operations.Admin', 'Quality.Admin'],
        },
        canActivate: [RoleGuard],
      },
    ],
  },
  /** Route that catches nonexisting routes and redirects them to home */
  {
    path: '**',
    redirectTo: '',
  },
];
